export const appConfig = {
  dataEndpoints: {
    commonData: '/mock/common-data.json',
    qrValues: '/mock/qr-values.json',
  },
  previewLayoutsEndpoint: '/mock/preview-layouts.json',
  autoLoadDataOnStart: true,
};

export type AppConfig = typeof appConfig;
